import { reachGoal } from './metrika.js';

// Модуль управления корзиной через localStorage
const CartModule = {
  // Получить корзину из localStorage
  getCart() {
    const cart = localStorage.getItem('cart');
    return cart ? JSON.parse(cart) : { items: [], dates: [], promoCode: null };
  },

  // Сохранить корзину в localStorage
  saveCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
    this.updateCartCounter();
  },

  // Получить только массив товаров
  getCartItems() {
    const cart = this.getCart();
    return cart.items || [];
  },

  // Сохранить только массив товаров
  saveCartItems(items) {
    const cart = this.getCart();
    cart.items = items;
    this.saveCart(cart);
  },

  // Добавить товар в корзину
  addToCart(itemId, count = 1) {
    const cart = this.getCart();
    const existingItem = cart.items.find(i => i.id === itemId);
    
    if (existingItem) {
      existingItem.count += count;
    } else {
      cart.items.push({ id: itemId, count: count });
    }
    
    this.saveCart(cart);
    reachGoal('cart_add');
    return cart;
  },

  // Удалить товар из корзины
  removeFromCart(itemId) {
    const cart = this.getCart();
    cart.items = cart.items.filter(i => i.id !== itemId);
    this.saveCart(cart);
    return cart;
  },

  // Изменить количество товара
  updateItemCount(itemId, delta) {
    const cart = this.getCart();
    const item = cart.items.find(i => i.id === itemId);
    
    if (item) {
      item.count += delta;
      if (item.count <= 0) {
        return this.removeFromCart(itemId);
      }
    }
    
    this.saveCart(cart);
    return cart;
  },

  // Установить количество товара
  setItemCount(itemId, count) {
    const cart = this.getCart();
    const item = cart.items.find(i => i.id === itemId);
    
    if (item) {
      if (count <= 0) {
        return this.removeFromCart(itemId);
      }
      item.count = count;
    }
    
    this.saveCart(cart);
    return cart;
  },

  // Очистить корзину
  clearCart() {
    this.saveCart({ items: [], dates: [], promoCode: null });
  },

  // Обновить счетчик в header
  updateCartCounter() {
    const cart = this.getCart();
    const totalItems = cart.items.reduce((sum, item) => sum + item.count, 0);
    const counter = document.querySelector('.cart .counter');
    if (counter) {
      counter.textContent = totalItems;
      if (totalItems > 0) {
        counter.style.display = 'flex';
      } else {
        counter.style.display = 'none';
      }
    }
  },

  // Получить количество товаров
  getItemsCount() {
    const cart = this.getCart();
    return cart.items.reduce((sum, item) => sum + item.count, 0);
  },

  // Обновить даты аренды
  updateDates(dates) {
    const cart = this.getCart();
    cart.dates = dates;
    this.saveCart(cart);
  },

  // Обновить промокод
  updatePromoCode(promoCode) {
    const cart = this.getCart();
    cart.promoCode = promoCode;
    this.saveCart(cart);
  }
};

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', () => {
  CartModule.updateCartCounter();
});

// Экспорт для использования в других скриптах
window.CartModule = CartModule;
